import { cn } from "@/lib/cn";

export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2 font-semibold tracking-tight", className)}>
      <svg viewBox="0 0 64 64" className="size-7" aria-hidden>
        <rect width="64" height="64" rx="14" className="fill-primary" />
        <path d="M19 20h26v5L27 39h18v5H19v-5l18-14H19z" fill="#fff" />
      </svg>
      Zeeta
    </span>
  );
}
